<section class="purchase-page">
  <header>
    <div>
      <p>Purchase workspace</p>
      <h2>
        {{
          step === 'choose'
            ? 'What are you purchasing?'
            : isUsed
              ? 'Used product purchase'
              : isCompanyUse
                ? 'Company use purchase'
                : 'New product purchase'
        }}
      </h2>
      <span>Purchase, inventory and marketplace listing remain separate.</span>
    </div>
    @if (step === 'details') {
      <button class="header-back" type="button" (click)="back()">
        <span class="material-symbols-outlined">arrow_back</span>Change type
      </button>
    }
  </header>
  @if (errorMessage) {
    <p class="notice error">{{ errorMessage }}</p>
  }
  @if (step === 'choose') {
    <div class="purchase-choice">
      @if (canUsePurchaseType('PROCUREMENT_COMPANY_USE')) {
        <button type="button" (click)="choose('CompanyUse')">
          <span class="choice-icon material-symbols-outlined">corporate_fare</span
          ><strong>Company use / self use</strong
          ><small>Purchase internal-use items without adding them to sale inventory.</small
          ><span class="choice-arrow material-symbols-outlined">arrow_forward</span>
        </button>
      }
      @if (canUsePurchaseType('PROCUREMENT_NEW_PRODUCT')) {
        <button type="button" (click)="choose('SupplierProcurement')">
          <span class="choice-icon material-symbols-outlined">inventory_2</span
          ><strong>New product purchase</strong
          ><small
            >Purchase multiple new items from a supplier, using existing products or adding products
            not yet listed.</small
          ><span class="choice-arrow material-symbols-outlined">arrow_forward</span>
        </button>
      }
      @if (canUsePurchaseType('PROCUREMENT_USED_PRODUCT')) {
        <button type="button" (click)="choose('IndividualUsed')">
          <span class="choice-icon used material-symbols-outlined">person_search</span
          ><strong>Used product purchase</strong
          ><small>Buy one used item from a business or an Aadhaar-verified individual.</small
          ><span class="choice-arrow material-symbols-outlined">arrow_forward</span>
        </button>
      }
    </div>
  } @else {
    <form (ngSubmit)="save()" novalidate>
      @if (isUsed) {
        <section class="card seller-type-card">
          <div class="section-title">
            <div>
              <span class="step-number">1</span>
              <div>
                <h3>Who is selling this used product?</h3>
                <p>Select the seller type to continue with the correct verification.</p>
              </div>
            </div>
          </div>
          <div class="purchase-choice">
            <button
              type="button"
              [class.selected]="usedSellerType === 'Business'"
              (click)="chooseUsedSeller('Business')"
            >
              <span class="material-symbols-outlined">storefront</span
              ><strong>Business seller</strong
              ><small>Select an existing verified business or store.</small>
            </button>
            <button
              type="button"
              [class.selected]="usedSellerType === 'Individual'"
              (click)="chooseUsedSeller('Individual')"
            >
              <span class="material-symbols-outlined">person</span><strong>Individual seller</strong
              ><small>Verify the registered individual using Aadhaar.</small>
            </button>
          </div>
        </section>
      }
      @if (!isUsed || usedSellerType) {
        <section class="card">
          <div class="section-title">
            <div>
              <span class="step-number">{{ isUsed ? 2 : 1 }}</span>
              <h3>
                {{
                  purchaseType === 'IndividualUsed'
                    ? 'Verify individual seller'
                    : 'Select business seller'
                }}
              </h3>
            </div>
          </div>
          @if (
            purchaseType === 'SupplierProcurement' ||
            purchaseType === 'BusinessUsed' ||
            purchaseType === 'CompanyUse'
          ) {
            <div class="seller-search-row">
              <div class="seller-search-box">
                <span class="material-symbols-outlined">search</span>
                <input
                  name="supplierSearch"
                  [(ngModel)]="supplierSearch"
                  (focus)="showSupplierResults = true"
                  (input)="supplierSearchChanged()"
                  autocomplete="off"
                  placeholder="Search seller by name or mobile number"
                />
                @if (supplierId) {
                  <span class="seller-selected material-symbols-outlined">check_circle</span>
                }
                @if (showSupplierResults) {
                  <div class="search-results supplier-results">
                    @for (s of filteredSuppliers; track s.id) {
                      <button type="button" (click)="selectSupplier(s)">
                        <span class="result-icon material-symbols-outlined">storefront</span>
                        <span><strong>{{ s.name }}</strong><small>{{ s.phone || s.email || 'Business supplier' }}</small></span>
                        @if (s.id === supplierId) {
                          <span class="result-check material-symbols-outlined">check_circle</span>
                        }
                      </button>
                    } @empty {
                      <div class="search-no-result">No matching supplier found.</div>
                    }
                  </div>
                }
              </div>
              <button
                class="outline refresh-sellers"
                type="button"
                [disabled]="isLoadingSuppliers"
                (click)="loadSuppliers()"
              >
                <span class="material-symbols-outlined">refresh</span>
                {{ isLoadingSuppliers ? 'Loading…' : 'Refresh' }}
              </button>
              <button class="outline" type="button" (click)="toggleSupplierForm()">
                <span class="material-symbols-outlined">{{ showNewSupplier ? 'close' : 'person_add' }}</span>
                {{ showNewSupplier ? 'Cancel' : 'Add new supplier' }}
              </button>
            </div>
            @if (!isLoadingSuppliers && suppliers.length === 0) {
              <div class="seller-empty">
                <span class="material-symbols-outlined">person_add</span>
                <div><strong>No suppliers added yet</strong><small>Create your first supplier to continue this purchase. It will be selected automatically.</small></div>
                <button class="outline" type="button" (click)="showNewSupplier = true">Add supplier</button>
              </div>
            }
            @if (supplierFeedback) {
              <p class="supplier-feedback success"><span class="material-symbols-outlined">check_circle</span>{{ supplierFeedback }}</p>
            }
            @if (supplierError) {
              <p class="supplier-feedback error"><span class="material-symbols-outlined">error</span>{{ supplierError }}</p>
            }
            @if (showNewSupplier) {
              <div class="supplier-form">
                <input
                  name="sn"
                  [(ngModel)]="supplierForm.name"
                  placeholder="Supplier name"
                /><input
                  name="sc"
                  [(ngModel)]="supplierForm.contactName"
                  placeholder="Contact person"
                /><input
                  name="sp" type="tel" inputmode="numeric" autocomplete="tel" [ngModel]="supplierForm.phone" (ngModelChange)="supplierPhoneInput($event)" maxlength="10" pattern="[0-9]{10}"
                  placeholder="Mobile number"
                /><input
                  name="se"
                  [(ngModel)]="supplierForm.email"
                  placeholder="Email address"
                /><input
                  name="st"
                  [(ngModel)]="supplierForm.taxNumber"
                  placeholder="GSTIN / PAN (optional)"
                /><textarea
                  name="sa"
                  [(ngModel)]="supplierForm.address"
                  placeholder="Supplier address"
                ></textarea
                ><button type="button" [disabled]="isSavingSupplier" (click)="createSupplier()">
                  <span class="material-symbols-outlined">{{ isSavingSupplier ? 'progress_activity' : 'add_business' }}</span>
                  {{ isSavingSupplier ? 'Adding supplier…' : 'Save & select supplier' }}
                </button>
              </div>
            }
          } @else {
            <div class="verification-panel">
              <div class="form-grid">
                <input
                  name="phone" type="tel" [ngModel]="individualPhone" (ngModelChange)="individualPhoneInput($event)" maxlength="10" inputmode="numeric" autocomplete="tel" pattern="[0-9]{10}"
                  placeholder="Registered 10-digit mobile number"
                /><input
                  type="password"
                  name="aadhaar"
                  [(ngModel)]="aadhaarNumber"
                  maxlength="12"
                  inputmode="numeric"
                  placeholder="12-digit Aadhaar number"
                /><button type="button" [disabled]="isVerifying" (click)="lookupIndividual()">
                  {{ isVerifying ? 'Checking…' : 'Find seller & send OTP' }}
                </button>
              </div>
              @if (aadhaarReferenceId && !individualVerified) {
                <div class="otp-row">
                  <input
                    name="otp"
                    [(ngModel)]="aadhaarOtp"
                    maxlength="8"
                    inputmode="numeric"
                    placeholder="Enter Aadhaar OTP"
                  /><button type="button" [disabled]="isVerifying" (click)="verifyIndividual()">
                    Verify seller
                  </button>
                </div>
              }
              @if (individualSeller) {
                <div class="verified-seller" [class.ok]="individualVerified">
                  <span class="material-symbols-outlined">{{
                    individualVerified ? 'verified' : 'pending'
                  }}</span>
                  <div>
                    <strong>{{
                      individualSeller.aadhaarVerifiedName ||
                        (individualSeller.firstName || '') + ' ' + (individualSeller.lastName || '')
                    }}</strong
                    ><small
                      >{{ individualSeller.phoneNumber }} ·
                      {{ individualVerified ? 'Aadhaar verified' : 'Verification pending' }}</small
                    >
                  </div>
                </div>
              }
            </div>
          }
          @if (isUsed) {
            <div class="seller-required-details">
              <div class="seller-detail-summary">
                <span class="material-symbols-outlined">badge</span>
                <div>
                  <small>Seller details (mandatory)</small>
                  <strong>{{ currentSellerName || 'Select or verify a seller' }}</strong>
                  <span>{{ currentSellerPhone || '10-digit mobile number required' }}</span>
                </div>
              </div>
              <div class="readonly-seller-address" [class.missing]="!sellerAddress">
                <span class="material-symbols-outlined">location_on</span>
                <div>
                  <small>Seller address</small>
                  <strong>{{ sellerAddress || 'Address is missing in seller master' }}</strong>
                </div>
              </div>
            </div>
          }
        </section>
        <section class="listing-location" [class.empty-location]="!selectedStore">
          <span class="location-icon material-symbols-outlined">storefront</span>
          <div class="listing-location-copy">
            <span>Purchase location</span>
            @if (selectedStore) {
              <strong>{{ selectedStore.name }}</strong>
              <p>{{ selectedStoreAddress }}</p>
              <small>{{
                locationScope === 'platform' ? 'Platform inventory location' : 'Business location'
              }}</small>
            } @else {
              <strong>No assigned location selected</strong>
              <p>Ask an administrator to assign a store location to this user.</p>
            }
          </div>
          @if (stores.length) {
            <button class="location-action" type="button" (click)="changeLocation()">
              <span class="material-symbols-outlined">swap_horiz</span
              >{{ selectedStore ? 'Change location' : 'Choose location' }}
            </button>
          }
        </section>
        <section class="card ownership-evidence-card">
          <div class="section-title">
            <div>
              <span class="step-number">{{ isUsed ? 3 : 2 }}</span>
              <div>
                <h3>{{ isUsed ? 'Seller and purchase invoice' : 'Supplier invoice' }}</h3>
                @if (isUsed) {
                  <p>
                    Seller details and ID remain common. Add the seller's purchase invoice here if available; each product's original ownership bill is captured separately below.
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="form-grid evidence-controls">
            <input
              name="invoice"
              [(ngModel)]="sellerInvoiceNumber"
              [placeholder]="
                isUsed ? 'Seller purchase invoice number (optional)' : 'Supplier invoice number'
              "
            />
            <label class="upload"
                ><span class="material-symbols-outlined">upload_file</span>{{ isUsed ? 'Upload seller purchase invoice (optional)' : 'Upload bill images / PDF' }}
                <small>Up to 8 files</small><input
                  type="file"
                  accept="image/*,application/pdf"
                  multiple
                  (change)="evidenceChanged('invoice', $event)"
              /></label>
            @if (isUsed) {
              <label class="upload"
                ><span class="material-symbols-outlined">badge</span>Upload seller ID proof
                <small>Front/back images or PDF · up to 4</small><input
                  type="file"
                  accept="image/*,application/pdf"
                  multiple
                  (change)="evidenceChanged('identity', $event)"
              /></label>
            }
          </div>
          @if (sellerInvoices.length) {
            <div class="evidence-group">
              <strong>Bill / invoice evidence</strong>
              <div class="evidence-grid">
                @for (item of sellerInvoices; track item.url; let index = $index) {
                  <div class="evidence-tile">
                    @if (item.isPdf) {
                      <a [href]="item.url" target="_blank" rel="noopener" title="View bill PDF">
                        <span class="material-symbols-outlined">picture_as_pdf</span><small>View PDF</small>
                      </a>
                    } @else {
                      <button type="button" class="image-preview-button" (click)="openImage(item.url, 'Bill image ' + (index + 1))">
                        <img [src]="item.url" alt="Bill preview" />
                      </button>
                    }
                    <button class="image-remove" type="button" title="Remove bill" (click)="removeEvidence('invoice', index)"><span class="material-symbols-outlined">close</span></button>
                  </div>
                }
              </div>
            </div>
          }
          @if (isUsed && sellerIdentityDocuments.length) {
            <div class="evidence-group">
              <strong>Seller ID proof</strong>
              <div class="evidence-grid">
                @for (item of sellerIdentityDocuments; track item.url; let index = $index) {
                  <div class="evidence-tile">
                    @if (item.isPdf) {
                      <a [href]="item.url" target="_blank" rel="noopener" title="View identity PDF"><span class="material-symbols-outlined">picture_as_pdf</span><small>View PDF</small></a>
                    } @else {
                      <button type="button" class="image-preview-button" (click)="openImage(item.url, 'Seller ID ' + (index + 1))"><img [src]="item.url" alt="Seller ID preview" /></button>
                    }
                    <button class="image-remove" type="button" title="Remove ID proof" (click)="removeEvidence('identity', index)"><span class="material-symbols-outlined">close</span></button>
                  </div>
                }
              </div>
            </div>
          }
        </section>
        <section class="card">
          <div class="section-title">
            <div>
              <span class="step-number">{{ isUsed ? 4 : 3 }}</span>
              <div>
                <h3>Purchased products</h3>
                <p>
                  {{
                    isUsed
                      ? 'Create a fresh used-product stock draft · quantity locked to 1'
                      : 'Select an existing product or add a new product for this purchase.'
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="purchase-lines">
            @if (!isUsed) {
              <article class="purchase-entry" [class.editing]="editingLineIndex !== null">
                <div class="line-heading">
                  <strong>{{ editingLineIndex === null ? 'Add purchase item' : 'Edit item ' + ((editingLineIndex || 0) + 1) }}</strong>
                  @if (editingLineIndex !== null) {
                    <button class="outline compact-action" type="button" (click)="cancelLineEdit()">Cancel edit</button>
                  }
                </div>
                <div class="compact-purchase-row">
                  <div class="product-search-cell">
                    <div class="product-combobox">
                      <input
                        name="draftProductSearch"
                        [(ngModel)]="draftLine.productSearch"
                        (focus)="showProductResults = true"
                        (input)="productSearchChanged(draftLine)"
                        placeholder="Search product name or item code"
                        autocomplete="off"
                      />
                      @if (showProductResults) {
                        <div class="search-results product-results">
                          @if (isSearchingProducts) {
                            <div class="search-loading"><span class="material-symbols-outlined">progress_activity</span>Searching products…</div>
                          }
                          @for (saved of filteredSavedPurchaseItems(draftLine); track saved.title + '|' + saved.modelName) {
                            <button type="button" (click)="selectSavedPurchaseItem(draftLine, saved)">
                              <span class="result-icon material-symbols-outlined">draft</span>
                              <span><strong>{{ saved.title }}</strong><small>{{ saved.modelName || 'New item saved in this purchase' }}</small></span>
                              <span class="result-source">Saved</span>
                            </button>
                          }
                          @for (product of filteredProducts(draftLine); track product.id) {
                            <button type="button" (click)="selectExistingProduct(draftLine, product.id)">
                              <span class="result-icon material-symbols-outlined">inventory_2</span>
                              <span><strong>{{ product.title }}</strong><small>{{ product.modelName || 'New product' }}</small></span>
                            </button>
                          } @empty {
                            @if (!isSearchingProducts) {
                              <div class="search-no-result">No matching product. Use “Create new item”.</div>
                            }
                          }
                        </div>
                      }
                    </div>
                    <button class="outline add-inline" type="button" (click)="createNewLineItem(draftLine)">
                      <span class="material-symbols-outlined">add</span>Create new item
                    </button>
                  </div>
                  <input type="number" name="draftQty" [(ngModel)]="draftLine.quantity" min="1" placeholder="Qty" />
                  <input type="number" name="draftCost" [(ngModel)]="draftLine.unitCost" min="0.01" placeholder="Per-piece price" />
                  <input type="number" name="draftExtra" [(ngModel)]="draftLine.extraCost" min="0" placeholder="Extra charges" />
                  <div class="compact-total"><span>Total</span><strong>{{ format(((draftLine.unitCost || 0) + (draftLine.extraCost || 0)) * (draftLine.quantity || 1)) }}</strong></div>
                </div>
                @if (draftLine.isCreatingNew) {
                  <div class="inline-new-item">
                    <div><span class="material-symbols-outlined">add_box</span><div><strong>Create new item</strong><small>Save its details, then add it to this purchase.</small></div></div>
                    <div class="line-grid">
                      <input name="draftTitle" [(ngModel)]="draftLine.title" placeholder="Item/product name" required />
                      <input name="draftModel" [(ngModel)]="draftLine.modelName" placeholder="Item code / SKU (optional)" />
                      <textarea name="draftDescription" [(ngModel)]="draftLine.description" placeholder="Description, unit or classification"></textarea>
                    </div>
                    <div class="new-item-media">
                      <label class="upload"><span class="material-symbols-outlined">image</span>Thumbnail (optional)<input type="file" accept="image/*" (change)="lineThumbnailChanged(draftLine, $event)" /></label>
                      <label class="upload"><span class="material-symbols-outlined">collections</span>Other images<input type="file" accept="image/*" multiple (change)="lineGalleryChanged(draftLine, $event)" /></label>
                    </div>
                    @if (draftLine.thumbnailUrl || draftLine.galleryUrls.length) {
                      <div class="product-image-strip">
                        @if (draftLine.thumbnailUrl) {
                          <figure class="primary-image"><button class="image-preview-button" type="button" (click)="openImage(draftLine.thumbnailUrl, 'Product thumbnail')"><img [src]="draftLine.thumbnailUrl" alt="Product thumbnail" /></button><span>Thumbnail</span><button class="image-remove" type="button" aria-label="Remove thumbnail" (click)="removeLineImage(draftLine, 'thumbnail')"><span class="material-symbols-outlined">close</span></button></figure>
                        }
                        @for (url of draftLine.galleryUrls; track url; let imageIndex = $index) {
                          <figure><button class="image-preview-button" type="button" (click)="openImage(url, 'Product image ' + (imageIndex + 1))"><img [src]="url" alt="Product image" /></button><button class="image-remove" type="button" aria-label="Remove product image" (click)="removeLineImage(draftLine, 'gallery', imageIndex)"><span class="material-symbols-outlined">close</span></button></figure>
                        }
                      </div>
                    }
                    <div class="inline-save-actions"><button type="button" (click)="saveInlineItem(draftLine)"><span class="material-symbols-outlined">save</span>Save product details</button></div>
                  </div>
                }
                @if (draftLine.inlineSaved && !draftLine.isCreatingNew) {
                  <div class="inline-saved"><span class="material-symbols-outlined">check_circle</span><div><strong>{{ draftLine.title }}</strong><small>New product details ready</small></div><button class="outline" type="button" (click)="draftLine.isCreatingNew = true">Edit details</button></div>
                }
                <div class="entry-actions">
                  <button type="button" (click)="addOrUpdatePurchaseLine()"><span class="material-symbols-outlined">{{ editingLineIndex === null ? 'add_circle' : 'save' }}</span>{{ editingLineIndex === null ? 'Add item' : 'Update item' }}</button>
                </div>
              </article>
              @if (lines.length) {
                <div class="confirmed-items-heading"><div><strong>{{ lines.length }} item{{ lines.length === 1 ? '' : 's' }} added</strong><small>Ready for this purchase voucher</small></div><span>{{ format(total) }}</span></div>
              }
              @for (line of lines; track $index; let i = $index) {
                <article class="confirmed-item" [class.current-edit]="editingLineIndex === i">
                  <div class="confirmed-index">{{ i + 1 }}</div>
                  <div class="confirmed-copy"><strong>{{ line.title }}</strong><small>{{ line.modelName || (line.productId ? 'Catalogue product' : 'New product') }}</small></div>
                  <div class="confirmed-metric"><small>Qty</small><strong>{{ line.quantity }}</strong></div>
                  <div class="confirmed-metric"><small>Unit cost</small><strong>{{ format(line.unitCost || 0) }}</strong></div>
                  <div class="confirmed-metric"><small>Total</small><strong>{{ format(((line.unitCost || 0) + (line.extraCost || 0)) * (line.quantity || 1)) }}</strong></div>
                  <div class="confirmed-actions"><button class="outline" type="button" (click)="editPurchaseLine(i)"><span class="material-symbols-outlined">edit</span>Edit</button><button class="remove" type="button" (click)="removeLine(i)"><span class="material-symbols-outlined">delete</span></button></div>
                </article>
              }
            } @else {
              <article class="purchase-entry used-entry" [class.editing]="editingLineIndex !== null">
                <div class="line-heading"><strong>{{ editingLineIndex === null ? 'Add used product' : 'Edit used product ' + ((editingLineIndex || 0) + 1) }}</strong>@if (editingLineIndex !== null) { <button class="outline compact-action" type="button" (click)="cancelLineEdit()">Cancel edit</button> }</div>
                <div class="line-grid">
                  <input name="usedDraftTitle" [(ngModel)]="draftLine.title" placeholder="Product title *" required />
                  <input name="usedDraftModel" [(ngModel)]="draftLine.modelName" placeholder="Item code / serial number (optional)" />
                  <select name="usedIdentifierType" [(ngModel)]="draftLine.identifierType">
                    <option value="">Unique identifier type (optional)</option>
                    <option value="IMEI">IMEI (mobile/tablet)</option>
                    <option value="SerialNumber">Serial number</option>
                    <option value="VehicleRegistration">Vehicle registration number</option>
                    <option value="Other">Other unique number</option>
                  </select>
                  <input name="usedIdentifierValue" [(ngModel)]="draftLine.identifierValue" [placeholder]="draftLine.identifierType === 'VehicleRegistration' ? 'Vehicle number, e.g. UP14AB1234' : draftLine.identifierType === 'IMEI' ? '15-digit IMEI' : 'Unique number'" [disabled]="!draftLine.identifierType" />
                  <textarea name="usedDraftDescription" [(ngModel)]="draftLine.description" placeholder="Condition and product description"></textarea>
                  <input type="number" name="usedDraftCost" [(ngModel)]="draftLine.unitCost" min="0.01" placeholder="Purchase price *" />
                  <input type="number" name="usedDraftRepair" [(ngModel)]="draftLine.repairCost" min="0" placeholder="Repair cost (optional)" />
                  <input type="number" name="usedDraftExtra" [(ngModel)]="draftLine.extraCost" min="0" placeholder="Extra cost (optional)" />
                </div>
                <label class="upload"><span class="material-symbols-outlined">add_photo_alternate</span>Add product images (at least 1, up to 8)<input type="file" accept="image/*" multiple (change)="lineGalleryChanged(draftLine, $event)" /></label>
                @if (draftLine.galleryUrls.length) {
                  <div class="product-image-strip">@for (url of draftLine.galleryUrls; track url; let imageIndex = $index) { <figure [class.primary-image]="imageIndex === 0"><button class="image-preview-button" type="button" (click)="openImage(url, 'Used product image ' + (imageIndex + 1))"><img [src]="url" alt="Used product preview" /></button>@if (imageIndex === 0) { <span>Primary</span> }<button class="image-remove" type="button" aria-label="Remove product image" (click)="removeLineImage(draftLine, 'gallery', imageIndex)"><span class="material-symbols-outlined">close</span></button></figure> }</div>
                }
                <div class="item-evidence-panel">
                  <div class="item-evidence-heading"><span class="material-symbols-outlined">fact_check</span><div><strong>This product’s ownership evidence</strong><small>Evidence below belongs only to this used product.</small></div></div>
                  <div class="ownership-role-choice"><span>Original bill available?</span><div><button type="button" [class.selected]="draftLine.hasOriginalBill === true" (click)="draftLine.hasOriginalBill = true"><span class="material-symbols-outlined">receipt_long</span>Yes</button><button type="button" [class.selected]="draftLine.hasOriginalBill === false" (click)="draftLine.hasOriginalBill = false"><span class="material-symbols-outlined">photo_camera</span>No</button></div></div>
                  @if (draftLine.hasOriginalBill === true) {
                    <input name="usedDraftInvoiceNumber" [(ngModel)]="draftLine.invoiceNumber" placeholder="Bill / invoice number (optional)" />
                    <label class="upload"><span class="material-symbols-outlined">upload_file</span>Upload this product’s bill<small>Images or PDF · up to 8</small><input type="file" accept="image/*,application/pdf" multiple (change)="lineEvidenceChanged(draftLine, 'invoice', $event)" /></label>
                    @if (draftLine.invoices.length) { <div class="evidence-grid">@for (item of draftLine.invoices; track item.url; let index = $index) { <div class="evidence-tile">@if (item.isPdf) { <a [href]="item.url" target="_blank" rel="noopener"><span class="material-symbols-outlined">picture_as_pdf</span><small>View PDF</small></a> } @else { <button type="button" class="image-preview-button" (click)="openImage(item.url, 'Product bill ' + (index + 1))"><img [src]="item.url" alt="Product bill" /></button> }<button class="image-remove" type="button" (click)="removeLineEvidence(draftLine, 'invoice', index)"><span class="material-symbols-outlined">close</span></button></div> }</div> }
                  } @else if (draftLine.hasOriginalBill === false) {
                    <textarea name="usedDraftMissingBill" [(ngModel)]="draftLine.missingBillReason" placeholder="Why is this product’s original bill unavailable? *"></textarea>
                    <label class="upload"><span class="material-symbols-outlined">photo_camera</span>Seller with this product photo<small>Required · up to 4 images</small><input type="file" accept="image/*" multiple (change)="lineEvidenceChanged(draftLine, 'verification', $event)" /></label>
                    @if (draftLine.verificationPhotos.length) { <div class="evidence-grid">@for (item of draftLine.verificationPhotos; track item.url; let index = $index) { <div class="evidence-tile"><button type="button" class="image-preview-button" (click)="openImage(item.url, 'Seller with product ' + (index + 1))"><img [src]="item.url" alt="Seller with product" /></button><button class="image-remove" type="button" (click)="removeLineEvidence(draftLine, 'verification', index)"><span class="material-symbols-outlined">close</span></button></div> }</div> }
                  }
                  <div class="ownership-role-choice"><span>Is selected seller the owner of this product?</span><div><button type="button" [class.selected]="draftLine.isSellerProductOwner" (click)="draftLine.isSellerProductOwner = true">Yes</button><button type="button" [class.selected]="!draftLine.isSellerProductOwner" (click)="draftLine.isSellerProductOwner = false">No, mediator</button></div></div>
                  @if (!draftLine.isSellerProductOwner) {
                    <div class="product-owner-card item-owner"><div class="product-owner-heading"><span class="material-symbols-outlined">person_pin</span><div><strong>Actual owner of this product</strong><small>Mandatory when seller is a mediator.</small></div></div><div class="form-grid"><input name="usedOwnerName" [(ngModel)]="draftLine.productOwnerName" placeholder="Owner full name *" /><input name="usedOwnerPhone" type="tel" inputmode="numeric" maxlength="10" [ngModel]="draftLine.productOwnerPhone" (ngModelChange)="usedOwnerPhoneInput(draftLine, $event)" placeholder="Owner 10-digit mobile *" /></div><textarea name="usedOwnerAddress" [(ngModel)]="draftLine.productOwnerAddress" placeholder="Owner complete address *"></textarea><label class="upload"><span class="material-symbols-outlined">badge</span>Upload owner ID proof<small>{{ draftLine.productOwnerIdentityDocuments.length ? draftLine.productOwnerIdentityDocuments.length + ' file(s) selected' : 'Images or PDF · up to 4' }}</small><input type="file" accept="image/*,application/pdf" multiple (change)="lineEvidenceChanged(draftLine, 'ownerIdentity', $event)" /></label>@if (draftLine.productOwnerIdentityDocuments.length) { <div class="evidence-grid">@for (item of draftLine.productOwnerIdentityDocuments; track item.url; let index = $index) { <div class="evidence-tile">@if (item.isPdf) { <a [href]="item.url" target="_blank" rel="noopener"><span class="material-symbols-outlined">picture_as_pdf</span><small>View PDF</small></a> } @else { <button type="button" class="image-preview-button" (click)="openImage(item.url, 'Owner ID ' + (index + 1))"><img [src]="item.url" alt="Owner ID" /></button> }<button class="image-remove" type="button" (click)="removeLineEvidence(draftLine, 'ownerIdentity', index)"><span class="material-symbols-outlined">close</span></button></div> }</div> }</div>
                  }
                </div>
                <div class="used-entry-footer"><div><span>Product total</span><strong>{{ format((draftLine.unitCost || 0) + (draftLine.repairCost || 0) + (draftLine.extraCost || 0)) }}</strong></div><button type="button" (click)="addOrUpdatePurchaseLine()"><span class="material-symbols-outlined">{{ editingLineIndex === null ? 'save' : 'edit' }}</span>{{ editingLineIndex === null ? 'Save & add product' : 'Update product' }}</button></div>
              </article>
              @if (lines.length) { <div class="confirmed-items-heading"><div><strong>{{ lines.length }} used product{{ lines.length === 1 ? '' : 's' }} added</strong><small>Saved in this invoice draft</small></div><span>{{ format(total) }}</span></div> }
              @for (line of lines; track $index; let i = $index) {
                <article class="confirmed-item used-confirmed" [class.current-edit]="editingLineIndex === i">
                  <div class="confirmed-index">{{ i + 1 }}</div>
                  <div class="confirmed-copy"><strong>{{ line.title }}</strong><small>{{ line.modelName || 'Used product' }} · {{ line.galleryUrls.length }} image{{ line.galleryUrls.length === 1 ? '' : 's' }}</small></div>
                  <div class="confirmed-metric"><small>Purchase</small><strong>{{ format(line.unitCost || 0) }}</strong></div>
                  <div class="confirmed-metric"><small>Repair + extra</small><strong>{{ format((line.repairCost || 0) + (line.extraCost || 0)) }}</strong></div>
                  <div class="confirmed-metric"><small>Total</small><strong>{{ format((line.unitCost || 0) + (line.repairCost || 0) + (line.extraCost || 0)) }}</strong></div>
                  <div class="confirmed-actions"><button class="outline" type="button" (click)="editPurchaseLine(i)"><span class="material-symbols-outlined">edit</span>Edit</button><button class="remove" type="button" (click)="removeLine(i)"><span class="material-symbols-outlined">delete</span></button></div>
                </article>
              }
            }
          </div>
        </section>
        <section class="card franchise-funding-card">
          <div class="section-title"><div><span class="step-number">₹</span><div><h3>Final step · Purchase funding</h3><p>Select company and/or franchise funds only after all products and charges are complete.</p></div></div></div>
          <label class="company-fund-option"><input type="checkbox" name="companyFundEnabled" [(ngModel)]="companyFundEnabled" /><span><strong>Company inventory fund</strong><small>{{ format(companyFundBalance) }} available at {{ selectedStore?.name || 'this location' }}</small></span><b>{{ format(businessFunding) }}</b></label>
          <div class="form-grid"><select #fundPicker (change)="addFranchiseFund(fundPicker.value); fundPicker.value=''"><option value="">Add franchise fund</option>@for (partner of franchisePartners; track partner.id) { <option [value]="partner.id">{{ partner.name }} · {{ format(partner.available) }} available</option> }</select></div>
          @for (row of franchiseAllocations; track row.franchisePartnerId; let i=$index) { <div class="fund-allocation-row"><div><strong>{{franchiseName(row.franchisePartnerId)}}</strong><small>{{format(franchiseAvailable(row.franchisePartnerId))}} available</small></div><label><span>Amount</span><input type="number" [name]="'fundAmount'+i" min="0.01" [max]="franchiseAvailable(row.franchisePartnerId)" [(ngModel)]="row.amount" (ngModelChange)="allocationAmountChanged(row)"></label><label><span>Purchase %</span><input type="number" [name]="'fundPercent'+i" min="0.01" max="100" [(ngModel)]="row.percentage" (ngModelChange)="allocationPercentageChanged(row)"></label><button type="button" class="remove" (click)="removeFranchiseFund(i)"><span class="material-symbols-outlined">close</span></button></div> }
          <div class="fund-summary"><span>Franchise funds <strong>{{format(totalFranchiseFunding)}}</strong></span><span>Company fund <strong>{{format(businessFunding)}}</strong></span><span>Total allocated <strong>{{format(totalFranchiseFunding + businessFunding)}}</strong></span></div>
          @if (!franchisePartners.length) { <small>No active franchise fund is available at this location.</small> }
        </section>
        <section class="card finish">
          <div class="form-grid purchase-charges">
            <label class="charge-field">
              <span>Discount</span>
              <div>
                <b>₹</b
                ><input
                  type="number"
                  name="discount"
                  [(ngModel)]="discountAmount"
                  min="0"
                  placeholder="0.00"
                />
              </div>
            </label>
            <label class="charge-field">
              <span>Applicable tax</span>
              <div>
                <b>₹</b
                ><input
                  type="number"
                  name="tax"
                  [(ngModel)]="taxAmount"
                  min="0"
                  placeholder="0.00"
                />
              </div>
            </label>
            <label class="charge-field">
              <span>Transport charges</span>
              <div>
                <b>₹</b
                ><input
                  type="number"
                  name="transport"
                  [(ngModel)]="transportAmount"
                  min="0"
                  placeholder="0.00"
                />
              </div>
            </label>
            <label class="charge-field">
              <span>Other charges</span>
              <div>
                <b>₹</b
                ><input
                  type="number"
                  name="otherCharges"
                  [(ngModel)]="otherCharges"
                  min="0"
                  placeholder="0.00"
                />
              </div>
            </label>
            <label class="charge-field">
              <span>Amount paid</span>
              <div>
                <b>₹</b
                ><input
                  type="number"
                  name="amountPaid"
                  [(ngModel)]="amountPaid"
                  min="0"
                  [max]="total"
                  placeholder="0.00"
                />
              </div>
            </label>
            <label class="charge-field payment-field">
              <span>Payment method</span>
              <select name="paymentMethod" [(ngModel)]="paymentMethod">
                <option value="">Select method (optional)</option>
                <option value="Cash">Cash</option>
                <option value="UPI">UPI</option>
                <option value="BankTransfer">Bank transfer</option>
                <option value="Card">Card</option>
                <option value="Credit">Credit</option>
              </select>
            </label>
          </div>
          <textarea
            name="notes"
            [(ngModel)]="notes"
            placeholder="Purchase notes (optional)"
          ></textarea>
          <div>
            <span>Total purchase</span><strong>{{ format(total) }}</strong>
          </div>
          @if (errorMessage) {
            <p class="notice error form-error">{{ errorMessage }}</p>
          }
          <div class="purchase-actions">
            <button class="outline" type="submit" [disabled]="isSaving">
              {{ isSaving ? 'Saving…' : 'Save draft' }}</button
            >@if (canPostPurchase) { <button type="button" [disabled]="isSaving" (click)="save(true)">
              {{ isSaving ? 'Posting…' : 'Post purchase & create voucher' }}
            </button> }
          </div>
          @if (successMessage) {
            <div id="purchase-complete" class="notice success purchase-complete"><span class="material-symbols-outlined">check_circle</span><div><strong>Purchase completed</strong><p>{{ successMessage }}</p>@if (completedVoucherUrl) { <a [href]="completedVoucherUrl" target="_blank" rel="noopener">View voucher</a> }</div></div>
          }
        </section>
      }
    </form>
  }
  @if (isLocationPickerOpen) {
    <div class="dialog-backdrop" role="presentation" (click)="closeLocationPicker()">
      <section
        class="location-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="purchase-location-title"
        (click)="$event.stopPropagation()"
      >
        <div class="dialog-heading">
          <div>
            <h3 id="purchase-location-title">Choose business location</h3>
            <p>The purchased inventory will be received at this location.</p>
          </div>
          <button
            class="dialog-close"
            type="button"
            title="Close"
            aria-label="Close location picker"
            (click)="closeLocationPicker()"
          >
            <span class="material-symbols-outlined">close</span>
          </button>
        </div>
        <div class="location-list">
          @for (store of stores; track store.id) {
            <label class="location-choice" [class.selected]="pendingStoreId === store.id"
              ><input
                type="radio"
                name="purchaseLocation"
                [value]="store.id"
                [(ngModel)]="pendingStoreId"
              /><span class="material-symbols-outlined">storefront</span
              ><span
                ><strong>{{ store.name }}</strong
                ><small
                  >{{ store.addressLine2 || store.addressLine1 || store.area }}, {{ store.city }},
                  {{ store.state }} {{ store.postalCode }}</small
                ></span
              ></label
            >
          }
        </div>
        <div class="dialog-actions">
          <button class="secondary" type="button" (click)="closeLocationPicker()">Cancel</button
          ><button type="button" [disabled]="!pendingStoreId" (click)="confirmLocationChange()">
            <span class="material-symbols-outlined">check</span>Use location
          </button>
        </div>
      </section>
    </div>
  }
  @if (fullImageUrl) {
    <div class="image-lightbox" role="presentation" (click)="closeImage()">
      <section
        class="image-lightbox-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="image-preview-title"
        (click)="$event.stopPropagation()"
      >
        <header>
          <div>
            <strong id="image-preview-title">{{ fullImageAlt }}</strong>
            <small>Full image preview</small>
          </div>
          <button
            type="button"
            title="Close preview"
            aria-label="Close preview"
            (click)="closeImage()"
          >
            <span class="material-symbols-outlined">close</span>
          </button>
        </header>
        <div class="image-lightbox-canvas">
          <img [src]="fullImageUrl" [alt]="fullImageAlt" />
        </div>
      </section>
    </div>
  }
</section>
